import { HStack } from '@/components/Layout/Stacks'
import { useNavbarRef } from '@/components/Navbar/navbar-offset-provider'
import { cn } from '@/lib/utils'
import React from 'react'

interface NavbarWrapperProps {
  children: React.ReactNode
  className?: string
}

export function NavbarWrapper({ children, className }: NavbarWrapperProps) {
  const navbarRef = useNavbarRef()

  return (
    <header
      ref={navbarRef}
      id="navbar-header"
      className={cn(
        'bg-background border-b border-border sticky top-0 z-10 min-h-16 flex items-center',
        className,
      )}
    >
      <HStack
        className="px-4 py-3 flex-1 gap-16"
        justify="between"
        align="center"
      >
        {children}
      </HStack>
    </header>
  )
}
